import { DeepPartial } from 'kuaidong-model'
import { E_REWARD_ITEM_TYPE } from '../models/reward'
import { AppUtil, ArrayUtil, UIUtil } from 'kuaidong-lib'
import { rewardService as kdRewardService } from 'kuaidong-service'
import { IActivityData, IActivityMatch, IActivityStage } from '../models/config'
import { RewardType, RewardTypeKoiFish, IRewardPopupReward, IRewardPopupRewards } from '../models/reward'

import ImgRewardPopupTitle from '../images/img_reward_popup_title@2x.png'
import ImgRewardPopupBtnOk from '../images/img_reward_popup_btn_ok@2x.png'

export function jumpToUsePage(itemType: E_REWARD_ITEM_TYPE, func: (...args: any[]) => void) {
  switch (itemType) {
    case E_REWARD_ITEM_TYPE.C_EQUIPMENT: // 装备
    case E_REWARD_ITEM_TYPE.C_SUIT: // 运动秀
    case E_REWARD_ITEM_TYPE.C_CLOTHING: // 运动秀
      AppUtil.startDrill('funsports_test_2209') // 我的运动秀
      func('funsports_test_2209')
      break
    case E_REWARD_ITEM_TYPE.C_EGG_BATTERY:
    case E_REWARD_ITEM_TYPE.C_EGG_COIN:
    case E_REWARD_ITEM_TYPE.C_EGG_DIAMOND:
    case E_REWARD_ITEM_TYPE.C_EGG_WEAPON:
    case E_REWARD_ITEM_TYPE.C_VIRTUAL_PRODUCT: // 虚拟商品也跳火枪手
      AppUtil.startDrill('game_pengpeng_soldier_2312') // 火枪手
      func('game_pengpeng_soldier_2312')
      break
    case E_REWARD_ITEM_TYPE.C_GAME_FRUIT_KNIFE:
    case E_REWARD_ITEM_TYPE.C_GAME_FRUIT_SCENE:
    case E_REWARD_ITEM_TYPE.C_GAME_FRUIT_STARFRUIT:
      AppUtil.startDrill('game_fruit_master_2312') // 切水果
      func('game_fruit_master_2312')
      break
    case E_REWARD_ITEM_TYPE.C_BLAST_SCENE:
    case E_REWARD_ITEM_TYPE.C_BLAST_TICKET:
    case E_REWARD_ITEM_TYPE.C_BLAST_CANNON_SKIN:
    case E_REWARD_ITEM_TYPE.C_BLAST_BALL_SKIN:
      AppUtil.startDrill('game_blast_battery_2310') // 爆破英雄
      func('game_blast_battery_2310')
      break
    case E_REWARD_ITEM_TYPE.C_ENERGY_BEAN: // 能量豆
      AppUtil.openNativePage('energy_shop') // 能量豆商店
      func('energy_shop')
      break
    case E_REWARD_ITEM_TYPE.C_S_PLUS: // 会员
    case E_REWARD_ITEM_TYPE.C_TWIST_BOTTLE: // 扭蛋瓶
      AppUtil.jump2NativePageByName('dailyReward') // 每日福利
      func('dailyReward')
      break
    case E_REWARD_ITEM_TYPE.C_DRAGON: // 龙
    case E_REWARD_ITEM_TYPE.C_DRAGON_COIN: // 龙
    case E_REWARD_ITEM_TYPE.C_DRAGON_EGG: // 龙
    case E_REWARD_ITEM_TYPE.C_DRAGON_CRYSTAL:
      AppUtil.isAppVersionHigherThan('3.1.0').then((res) => {
        if (res) {
          AppUtil.startDrill('game_dragon_knight_2404')
        } else {
          UIUtil.checkFailed('客户端版本过低，请升级')
        }
      }), // 飞龙
        func('game_dragon_knight_2404')
      break
    case E_REWARD_ITEM_TYPE.C_ISLAND_FURNITURE:
    case E_REWARD_ITEM_TYPE.C_STAR_SHELL:
      AppUtil.isAppVersionHigherThan('3.1.0').then((res) => {
        if (res) {
          AppUtil.startDrill('sports_island_2403')
        } else {
          UIUtil.checkFailed('客户端版本过低，请升级')
        }
      }) // 运动岛
      func('sports_island_2403')
      break
    case E_REWARD_ITEM_TYPE.C_PARKOUR_PROPS: //
    case E_REWARD_ITEM_TYPE.C_PARKOUR_SHIELD: //
    case E_REWARD_ITEM_TYPE.C_PARKOUR_COIN: //
      AppUtil.isAppVersionHigherThan('3.0.52').then((res) => {
        if (res) {
          AppUtil.startDrill('game_parkour_2401')
        } else {
          UIUtil.checkFailed('请升级版本后再跑起来吧')
        }
      }), // 跑酷
        func('game_parkour_2401')
      break
    case E_REWARD_ITEM_TYPE.MEDAL:
      AppUtil.jump2NativePageByName('myHonor')
      func('myHonor')
      break
    case E_REWARD_ITEM_TYPE.C_CARD_PACKAGE:
    case E_REWARD_ITEM_TYPE.C_CARD_DIAMOND:
      AppUtil.jump2NativePageByName('sportsCardStore')
      func('sportsCardStore')
      break
    case E_REWARD_ITEM_TYPE.C_PASTRY_SKIN:
      AppUtil.startDrill('game_super_pastry_2410') // 动感跳糕
      func('game_super_pastry_2410')
      break
    case E_REWARD_ITEM_TYPE.C_ANIMAL_KINGDOM_DIAMOND:
      AppUtil.startDrill('game_animal_kingdom_2605') // 体感大作战
      func('game_animal_kingdom_2605')
      break
    case E_REWARD_ITEM_TYPE.C_SUPER_DUCK_DIAMOND:
    case E_REWARD_ITEM_TYPE.C_SUPER_DUCK_EGG:
      AppUtil.startDrill('game_super_duck_2601') // 天天下蛋龙
      func('game_super_duck_2601')
      break
    case E_REWARD_ITEM_TYPE.C_MONSTER_BATTLE_DIAMOND:
    case E_REWARD_ITEM_TYPE.C_MONSTER_BATTLE_ROLE:
      AppUtil.startDrill('game_hit_monster_2510') // 体感打怪兽
      func('game_hit_monster_2510')
      break
    case E_REWARD_ITEM_TYPE.C_FISH_ISLAND_PROP:
      AppUtil.startDrill('sports_island_farmland_2507', '', '', '', undefined, {
        ext_infos: { select_item: 'fish_island' },
      }) // 捕鱼岛
      func('sports_island_farmland_2507')
      break
    default:
      AppUtil.startDrill('game_pengpeng_soldier_2312') // 火枪手
      func('game_pengpeng_soldier_2312')
      break
  }
}

export function buildRewards(_data?: IActivityData | IActivityMatch | null) {
  let rewards: IActivityStage[] = []

  if (_data) {
    if ('extra_info' in _data) {
      rewards = _data.extra_info.stage_info_settings || []
    } else {
      rewards = [
        ...(_data.race_prize_config || []),
        ...(_data.rank_reward_config || []),
        ...(_data.stage_info_settings || []),
        ...(_data.achievement_settings || []),
      ]
    }
  }

  return rewards.map((_reward, _idx) => ({
    ..._reward,
    ...(_reward.pic_list?.[0] || {}),
    idx: _idx,
  }))
}

export function buildRewardMap(_data?: IActivityData | IActivityMatch | null) {
  return ArrayUtil.buildMapByKey(buildRewards(_data), 'stage_id')
}

export const buildRewardBtn = kdRewardService.buildRewardBtn

// base
export function buildRewardPopupReward(
  _reward: ReturnType<typeof buildRewards>[number],
  _base?: DeepPartial<IRewardPopupReward>
): IRewardPopupReward {
  const base = _base || {}

  return {
    id: _reward.stage_id,
    data: _reward,

    ...(_base || {}),

    title: {
      image: ImgRewardPopupTitle,
      label: '哇！恭喜你获得',
      ...(base.title || {}),
    },

    reward: {
      name: _reward.reward_name,
      image: _reward.reward_small_pic,
      ...(base.reward || {}),
    },

    btnOk: {
      image: ImgRewardPopupBtnOk,
      label: '开心收下',
      ...(base.btnOk || {}),
    },
  }
}

export function buildRewardPopupRewards(
  _rewards: ReturnType<typeof buildRewards>,
  _base?: DeepPartial<IRewardPopupRewards>
): IRewardPopupRewards {
  const base = _base || {}

  return {
    id: _rewards[0]?.stage_id,
    data: _rewards[0],

    ...(_base || {}),

    title: {
      image: ImgRewardPopupTitle,
      label: '哇！恭喜你获得',
      ...(base.title || {}),
    },

    rewards: _rewards
      .filter((_reward) => _reward)
      .map((_reward) => ({
        id: _reward.stage_id,
        data: _reward,
        name: _reward.reward_name,
        image: _reward.reward_small_pic,
      })),

    btnOk: {
      image: ImgRewardPopupBtnOk,
      label: '开心收下',
      ...(base.btnOk || {}),
    },
  }
}

export function rewardTypeKoiFish2RewardType(_type: RewardTypeKoiFish) {
  for (const item of Object.keys(RewardTypeKoiFish)) {
    if (RewardTypeKoiFish[item as keyof typeof RewardTypeKoiFish] === _type) {
      return RewardType[item as keyof typeof RewardTypeKoiFish]
    }
  }
}

export function useReward() {
  return {
    buildRewards,
    buildRewardMap,
    buildRewardBtn,
    buildRewardPopupReward,
    rewardTypeKoiFish2RewardType,
  }
}

export type IReward = ReturnType<typeof buildRewards>[number]

export interface IRewardsPreviewItem {
  item_name: string
  item_pic: string
}

export interface IRewardsPreview {
  reward_name: string
  finished_pic?: string
  reward_items?: IRewardsPreviewItem[]
}

/** Parse `@keyword@` markers in reward description for KdText2 highlight. */
export function parseRewardDesc(_finishedPic: string) {
  const keywords: string[] = []
  const text = _finishedPic.replace(/@([^@]+)@/g, (_match, _keyword) => {
    keywords.push(_keyword)
    return _keyword
  })

  return { text, keywords }
}
